// get_article
export const GET_ARTICLE = 'get_article';
export const GET_ARTICLE_SUCCESSFUL = 'get_article_successfull';
export const GET_ARTICLE_FAILED = 'get_article_failed';

// create_article
export const CREATE_ARTICLE = 'create_article';
export const CREATE_ARTICLE_SUCCESSFUL = 'create_article_successfull';
export const CREATE_ARTICLE_FAILED = 'create_article_failed';

// update_article
export const UPDATE_ARTICLE = 'update_article';
export const UPDATE_ARTICLE_SUCCESSFUL = 'update_article_successfull';
export const UPDATE_ARTICLE_FAILED = 'update_article_failed';

// delete_article
export const DELETE_ARTICLE = 'delete_article';
export const DELETE_ARTICLE_SUCCESSFUL = 'delete_article_successfull';
export const DELETE_ARTICLE_FAILED = 'delete_article_failed';
